import { Breakpoint, Color, FontWeight, SimpleMarkdown } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { Color as OldColor } from '../../theme';
import { Thumbnail } from '../thumbnail/thumbnail.component';

import { ContainerProps, ThumbnailTitleProps } from './searchPopup.types';

export const Container = styled.div<ContainerProps>`
  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-100px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slideOutLeft {
    from {
      opacity: 1;
      transform: translateX(0);
    }

    to {
      opacity: 0;
      transform: translateX(-100px);
    }
  }

  padding: 40px 16px;
  animation: ${({ $visible }: ContainerProps): string => $visible
    ? 'slideInLeft 0.3s ease-out forwards'
    : 'slideOutLeft 0.3s ease-out forwards'
};

  @media ${Breakpoint.Tablet} {
    padding: 40px 80px;
  }
`;

export const SearchBarWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  border-bottom: 1px solid ${OldColor.gray5};
  padding-bottom: 20px;
`;

export const SearchBarContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const SearchBarInput = styled.input`
  width: 100%;
  flex: 1;
  color: ${Color.Brand300};
  padding-left: 20px;
  margin-right: 10px;
  font-size: 15px;

  ::placeholder {
    color: ${OldColor.gray9};
  }

  @media ${Breakpoint.Tablet} {
    font-size: 24px;
  }
`;

export const SearchBarResults = styled.div`
  font-size: 13px;
  color: ${OldColor.gray3};
  margin-top: 20px;

  @media ${Breakpoint.Tablet} {
    margin-top: 0;
  }
`;

export const ThumbnailRow = styled.div`
  display: flex;
  max-width: 900px; 
`;

export const ThumbnailDetails = styled.div`
  display: flex;
  padding-top: 3px;
  padding-left: 10px;

  @media ${Breakpoint.Tablet} {
    padding-top: 15px;
    padding-left: 40px;
  }
`;

export const ThumbnailDetailsContent = styled.div`
  display: flex;
  flex-flow: column;
`;

export const ThumbnailTitle = styled.a<ThumbnailTitleProps>`
  text-decoration: none;
  color: ${OldColor.deepGray};
  font-size: 14px;
  line-height: 18px;
  font-weight: ${FontWeight.SemiBold};
  ${({ $disabled }: ThumbnailTitleProps): string | false => !$disabled && 'cursor: pointer'};
  
  @media ${Breakpoint.Tablet} {
    font-size: 16px;
  }
`;

export const ThumbnailCategory = styled.div`
  font-size: 10px;
  line-height: 2;
  text-align: left;
  color: ${OldColor.gray3};
  display: flex;
  margin-top: 3px;
  align-items: center;
  text-transform: uppercase;
  font-weight: ${FontWeight.SemiBold};

  svg {
    margin-right: 5px;
    width: 18px;
  }
`;

export const ThumbnailDescription = styled.p`
  font-weight: ${FontWeight.Light};
  font-size: 12px;
  line-height: 20px;
  margin-top: 6px;
  color: ${OldColor.deepGray};
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  
  @media ${Breakpoint.Tablet} {
    line-height: 22px;
    -webkit-line-clamp: 3;
    font-size: 14px;
  }
`;

export const NewsHeader = styled(SimpleMarkdown)`
  strong {
    color: ${OldColor.gray9};
    font-weight: ${FontWeight.Regular};
  }
`;

export const StyledThumbnail = styled(Thumbnail)`
  max-width: 120px;

  @media ${Breakpoint.Tablet} {
    max-width: none;
    width: 285px;
  }
`;

export const ResultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: center;
  margin-top: 25px;
`;
